import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const enableDisableDriveAction = getApiActionCreator(actionTypes.ENABLE_DISABLE_DRIVE_REQUEST);

export const enableDisableDrive = (assetId, isDisabled, gatewayID) => {
    return {
        type: actionTypes.ENABLE_DISABLE_DRIVE,
        assetId,
        isDisabled,
        gatewayID
    };
};
